export const state = () => ({
	notification_preferences: null,
});
export const getters = {
	getNotificationPreferences: (state: any) => state.notification_preferences,
};
export const mutations = {
	setNotificationPreferences(state: any, payload: any) {
		state.notification_preferences = payload;
	},
};
export const actions = {
	async fetchNotificationPreferences(state: any, payload: any) {
		return new Promise((resolve, reject) => {
			this.$axios
				.get('/api/user/settings')
				.then((res) => {
					state.commit('setNotificationPreferences', res.data);
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	async editNotificationPreferences(state: any, payload: any) {
		let notifications = JSON.parse(
			JSON.stringify(state.state.notification_preferences),
		);

		notifications.notifications[payload.setting] = payload.values;

		return new Promise((resolve, reject) => {
			this.$axios
				.put('/api/user/settings', notifications)
				.then((res) => {
					state.commit('setNotificationPreferences', res.data);
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	async editEmailPreferences(state: any, payload: any) {
		let notifications = JSON.parse(
			JSON.stringify(state.state.notification_preferences),
		);

		notifications.emails = {...notifications.emails, ...payload};

		return new Promise((resolve, reject) => {
			this.$axios
				.put('/api/user/settings', notifications)
				.then((res) => {
					state.commit('setNotificationPreferences', res.data);
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	updateNotificationPreferences(state: any, payload: any) {
		state.commit('setNotificationPreferences', payload);
	},
};
